<style lang="scss" scoped>
.sidebar-list__item {
  border-bottom: 1px solid $border-color;
  display: block;
  width: 100%;

  &:hover,
  &:focus,
  &.is-active {
    background: $lighten-bg;

    .icon-arrow-right {
      color: $primary;
    }
  }

  &:active,
  &.is-active {
    background: $body-bg;
  }

  &:last-child {
    border-bottom: 0;
  }

  a {
    color: $body-color;
    text-decoration: none;
    padding: 1rem;
    display: block;
  }

  i,
  span {
    vertical-align: middle;
  }

  span {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i {
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

<script>
export default {
  render(createElement) {
    return createElement(
      this.tag,
      {
        class: {
          'sidebar-list__item': true
        }
      },
      this.$slots.default
    );
  },
  props: {
    tag: {
      type: String,
      default: 'li'
    }
  }
};
</script>
